import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { ReactNode } from 'react';
import './radio-card-group.scss';
type RadioCardGroupProps = Readonly<{
  children: ReactNode;
  className?: string;
  testId?: string;
  name?: string;
}>;
export const RadioCardGroup = t0 => {
  const $ = _c(7);
  const {
    children,
    className,
    testId,
    name
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("radio-card-group", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== name || $[4] !== t1 || $[5] !== testId) {
    t2 = <fieldset className={t1} data-testid={testId} data-name={name}>{children}</fieldset>;
    $[2] = children;
    $[3] = name;
    $[4] = t1;
    $[5] = testId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};